"use strict";
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        function feedBack() {
            if (!$(".feedbackpane")[0]) {
                var feedbackData = new $dyn.controls.FeedbackPane();
                // Retrieve the active form name and unique ID before the dialog appears
                var activeForm_1 = $dyn.context($dyn.shell.getActiveForm());
                feedbackData.FormName($dyn.value(activeForm_1.FormName));
                feedbackData.FormUniqueId(activeForm_1.Id);
                var options_1 = {
                    context: feedbackData,
                    role: "Dialog",
                    templateId: "FeedbackPane",
                };
                $dyn.shell.createForm(options_1);
                $dyn.shell.dialog(options_1);
            }
        }
        ui.feedBack = feedBack;
    })(ui = $dyn.ui || ($dyn.ui = {}));
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                FeedbackPane_BrowserSessionHeader: "Session information",
                FeedbackPane_CancelButton: "Cancel",
                FeedbackPane_Caption: "Feedback",
                FeedbackPane_Dislike: "Dislike",
                FeedbackPane_IntroText: "Share your thoughts about Microsoft Dynamics 365 {0}.",
                FeedbackPane_Like: "Like",
                FeedbackPane_Privacy: "Thank you for taking the time to send us feedback. Your privacy is important to us. To protect your privacy, please don't include any personal information.",
                FeedbackPane_PrivacyLinkText: "Microsoft Privacy Statement",
                FeedbackPane_SubmitButton: "Submit",
            },
        });
        var FeedbackPane = /** @class */ (function () {
            function FeedbackPane() {
                var _this = this;
                this.Text = $dyn.observable("");
                this.FormName = $dyn.observable("");
                this.FormUniqueId = $dyn.observable("");
                this.ShowActivityId = $dyn.observable(false);
                this.ActivityId = $dyn.observable("");
                this.BrowserSessionActivityId = $dyn.computed(function () {
                    return $dyn.browserActivity.BrowserSessionActivity.Id;
                });
                this.AOSRoleInstance = $dyn.computed(function () {
                    return $dyn.browserActivity.AOSRoleInstance;
                });
                this.AOSId = $dyn.computed(function () {
                    return $dyn.browserActivity.aosId;
                });
                this.BrowserInteractionTimestamp = $dyn.computed(function () {
                    return $dyn.browserActivity.BrowserInteractionActivity.UtcTimestamp;
                });
                this.ShowSessionId = $dyn.computed(function () {
                    return !$dyn.browserActivity.SearchTraceLog;
                });
                this.ShowSessionIdAnchor = $dyn.computed(function () {
                    return $dyn.browserActivity.SearchTraceLog;
                });
                this.SearchTraceLogUrl = $dyn.computed(function () {
                    return $dyn.browserActivity.SearchTraceLogUrl;
                });
                // Type is a tristate variable
                this.Type = $dyn.observable($dyn.telemetry.FeedbackType.notSpecified);
                this.Liked = $dyn.computed(function () {
                    return $dyn.value(_this.Type) === $dyn.telemetry.FeedbackType.positive;
                });
                this.Disliked = $dyn.computed(function () {
                    return $dyn.value(_this.Type) === $dyn.telemetry.FeedbackType.negative;
                });
            }
            FeedbackPane.prototype.ToggleFeedbackType = function (feedbackType) {
                if ($dyn.value(this.Type) === feedbackType) {
                    this.Type($dyn.telemetry.FeedbackType.notSpecified);
                }
                else {
                    this.Type(feedbackType);
                }
            };
            FeedbackPane.prototype.Submit = function () {
                $dyn.telemetry.addUserFeedbackEvent(this.FormName(), this.FormUniqueId(), this.Type(), this.Text());
                $dyn.telemetry.flushTelemetryEvents();
                this.Close();
            };
            FeedbackPane.prototype.Cancel = function () {
                this.Close();
            };
            FeedbackPane.prototype.Close = function () {
                var _this = this;
                var form = $(".feedbackpane").closest("[data-dyn-role='Dialog']");
                var context = $dyn.context(form[0]);
                $dyn.applyFunction(context.Close, context, [{ closeCallback: function () { return _this.close(); } }]);
            };
            FeedbackPane.prototype.close = function () {
                this.ActivityId("");
                this.ShowActivityId(false);
            };
            return FeedbackPane;
        }());
        controls.FeedbackPane = FeedbackPane;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FeedbackPane.js.map
